(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saelg-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  function wire(root){
    if(root.__mtwVideoWired) return;
    var preview = root.querySelector('[data-mtw-vpreview]');
    var openEls = root.querySelectorAll('[data-mtw-vopen]');
    var lb = root.querySelector('[data-mtw-vlb]');
    var full = root.querySelector('[data-mtw-vfull]');
    if(!lb || !full) return;
    root.__mtwVideoWired = true;
    var lastFocus = null;

    // Nogle browsere starter ikke muted-autoplay af sig selv — giv den et skub.
    if(preview){ var p = preview.play(); if(p && p.catch){ p.catch(function(){}); } }

    function open(){
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if(preview){ try{ preview.pause(); }catch(e){} }
      full.muted = false;
      var pr = full.play(); if(pr && pr.catch){ pr.catch(function(){}); }
      var closeBtn = lb.querySelector('[data-mtw-vclose]');
      if(closeBtn) closeBtn.focus();
    }
    function close(){
      try{ full.pause(); }catch(e){}
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if(preview){ var p2 = preview.play(); if(p2 && p2.catch){ p2.catch(function(){}); } }
      if(lastFocus && lastFocus.focus){ lastFocus.focus(); }
    }

    for(var i=0;i<openEls.length;i++){ openEls[i].addEventListener('click', open); }
    var closeEls = lb.querySelectorAll('[data-mtw-vclose]');
    for(var j=0;j<closeEls.length;j++){ closeEls[j].addEventListener('click', close); }
    document.addEventListener('keydown', function(e){ if(!lb.hidden && (e.key === 'Escape' || e.key === 'Esc')){ close(); } });
  }
  function initAll(){
    var nodes = document.querySelectorAll('[data-mtw-video]');
    for(var i=0;i<nodes.length;i++){ wire(nodes[i]); }
  }
  if(document.readyState !== 'loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
